import { Injectable } from '@angular/core';
import config from '../config/config.json';

@Injectable({ providedIn: 'root' })
export default class Config {

	private readonly languageOverrides: Record<string, any> = {
		de_DE: { code: 'de', icon: 'de', nativeName: 'Deutsch', shortLabel: 'DEU' },
		en_GB: { code: 'en', icon: 'gb', nativeName: 'English', shortLabel: 'ENG' },
		es_ES: { code: 'es', icon: 'es', nativeName: 'Espa\u00f1ol', shortLabel: 'ESP' },
		et_EE: { code: 'et', icon: 'ee', nativeName: 'Eesti', shortLabel: 'EST' },
		fi_FI: { code: 'fi', icon: 'fi', nativeName: 'Suomi', shortLabel: 'FIN' },
		fr_FR: { code: 'fr', icon: 'fr', nativeName: 'Fran\u00e7ais', shortLabel: 'FRA' },
		lt_LT: { code: 'lt', icon: 'lt', nativeName: 'Lietuvi\u0173', shortLabel: 'LTU' },
		lv_LV: { code: 'lv', icon: 'lv', nativeName: 'Latvie\u0161u', shortLabel: 'LVA' },
		pl_PL: { code: 'pl', icon: 'pl', nativeName: 'Polski', shortLabel: 'POL' },
		ru_RU: { code: 'ru', icon: 'ru', nativeName: '\u0420\u0443\u0441\u0441\u043a\u0438\u0439', shortLabel: 'RUS' },
		sv_SE: { code: 'sv', icon: 'se', nativeName: 'Svenska', shortLabel: 'SWE' }
	};

	private readonly siffiLanguageDomains: Record<string, string> = {
		de_DE: 'https://de.siffi.com',
		en_GB: 'https://siffi.com',
		es_ES: 'https://siffi.es',
		et_EE: 'https://siffi.ee',
		fi_FI: 'https://siffi.fi',
		fr_FR: 'https://siffi.fr',
		lt_LT: 'https://siffi.lt',
		lv_LV: 'https://siffi.lv',
		ru_RU: 'https://ru.siffi.com',
		sv_SE: 'https://se.siffi.com'
	};
	
	getServiceLanguages() {
		return [
			'ENG', 'EST', 'FIN', 'FRA', 'ESP', 'RUS', 'LVA', 'LTU',
			'SWE', 'POL', 'DEU', 'MLT', 'UKR', 'NLD', 'GRC', 'ITA',
			'PRT', 'NOR', 'DNK', 'BGR', 'HUN', 'JPN', 'IDN', 'PHL',
			'KOR', 'BIH', 'HRV', 'CZE', 'ISL', 'ROU', 'SRB', 'SVK',
			'SVN', 'ALB', 'BRA', 'MSA', 'CMN', 'APC', 'TUR', 'ISR',
			'GEO', 'AZE', 'ARM', 'THA', 'IRN', 'VIE'
		];
	}

	getLanguageOverrides() {
		return this.languageOverrides;
	}
	
	getFlagCss(lang) {
		var css: any = 'c-flag u-osr-xs ';
		if (lang === 'EST') {
			css += 'c-flag--ee';
		} else if (lang === 'RUS') {
			css += 'c-flag--ru';
		} else if (lang === 'ENG') {
			css += 'c-flag--gb';
		} else if (lang === 'FIN') {
			css += 'c-flag--fi';
		} else if (lang === 'ESP' || lang == 'SPA') {
			css += 'c-flag--es';
		} else if (lang === 'FRA' || lang == 'FRE') {
			css += 'c-flag--fr';
		} else if (lang === 'SWE') {
			css += 'c-flag--se';
		} else if (lang === 'LAT' || lang == 'LVA') {
			css += 'c-flag--lv';
		} else if (lang === 'LIT' || lang == 'LTU') {
			css += 'c-flag--lt';
		} else if (lang === 'DEU' || lang == 'GER') {
			css += 'c-flag--de';
		} else if (lang === 'POL') {
			css += 'c-flag--pl';
		} else if (lang === 'PRT' || lang == 'POR') {
			css += 'c-flag--pt';
		} else if (lang === 'ITA') {
			css += 'c-flag--it';
		} else if (lang === 'NLD' || lang == 'DUT') {
			css += 'c-flag--nl';
		} else if (lang === 'MLT' || lang == 'MAL') {
			css += 'c-flag--mt';
		} else if (lang === 'UKR') {
			css += 'c-flag--ua';
		} else if (lang === 'GRC') {
			css += 'c-flag--gr';
		} else if (lang === 'BGR') {
			css += 'c-flag--bg';
		} else if (lang === 'DNK') {
			css += 'c-flag--dk';
		} else if (lang === 'PHL') {
			css += 'c-flag--ph';
		} else if (lang === 'HUN') {
			css += 'c-flag--hu';
		} else if (lang === 'IDN') {
			css += 'c-flag--id';
		} else if (lang === 'JPN') {
			css += 'c-flag--jp';
		} else if (lang === 'KOR') {
			css += 'c-flag--kr';
		} else if (lang === 'NOR') {
			css += 'c-flag--no';
		} else if (lang === 'BIH') {
			css += 'c-flag--ba';
		} else if (lang === 'HRV') {
			css += 'c-flag--hr';
		} else if (lang === 'CZE') {
			css += 'c-flag--cz';
		} else if (lang === 'ISL') {
			css += 'c-flag--is';
		} else if (lang === 'ROU') {
			css += 'c-flag--ro';
		} else if (lang === 'SRB') {
			css += 'c-flag--rs';
		} else if (lang === 'SVK') {
			css += 'c-flag--sk';
		} else if (lang === 'SVN') {
			css += 'c-flag--si';
		} else if (lang === 'ALB') {
			css += 'c-flag--al';
		} else if (lang === 'APC') {
			css += 'c-flag--ac';
		} else if (lang === 'CMN') {
			css += 'c-flag--cn';
		} else if (lang === 'BRA') {
			css += 'c-flag--br';
		} else if (lang === 'TUR') {
			css += 'c-flag--tr';
		} else if (lang === 'MSA') {
			css += 'c-flag--my';
		} else if (lang === 'THA') {
			css += 'c-flag--th';
		} else if (lang === 'ISR') {
			css += 'c-flag--il';
		} else if (lang === 'GEO') {
			css += 'c-flag--ge';
		} else if (lang === 'AZE') {
			css += 'c-flag--az';
		} else if (lang === 'ARM') {
			css += 'c-flag--am';
		} else if (lang === 'IRN') {
			css += 'c-flag--ir';
		} else if (lang === 'VIE') {
			css += 'c-flag--vn';
		}
		
		return css;
	}

	getPublicWebUrlUsingDomain(domain, ignorePrevisit?) {
		var base: any = 'https://www%s.' + domain;
		if (!ignorePrevisit && window.location.href.indexOf('eelvisiit') !== -1) {
			base = base.replace('www', 'eelvisiit');
		}
		switch (config.Settings.ENVIRONMENT.toLowerCase()) {
			case 'build':
			return base.replace('%s', '-build');
			case 'test':
			return base.replace('%s', '-test');
			case 'stage':
			return base.replace('%s', '-stage');
			case 'recovery':
			return base.replace('%s', '-recovery');
			case 'devel':
			return base.replace('%s', '-devel');
			case 'live':
			return base.replace('%s', '');
			default:
			return base.replace('%s', '');
		}
	}
	
	getPublicWebUrl() {
		var publicServerUrlTemplate: any = '';
		var host: any = window.location.hostname;
		if (host.includes("siffi")) {
			publicServerUrlTemplate = 'https://www%s.siffi.com';
		} else {
			publicServerUrlTemplate = 'https://www%s.minudoc.ee';
		}

		if ("{{ENVIRONMENT}}" == config.Settings.ENVIRONMENT) {
			return publicServerUrlTemplate.replace('%s', '-devel');
		}

		switch (config.Settings.ENVIRONMENT.toLowerCase()) {
			case 'build':
			return publicServerUrlTemplate.replace('%s', '-build');
			case 'test':
			return publicServerUrlTemplate.replace('%s', '-test');
			case 'stage':
			return publicServerUrlTemplate.replace('%s', '-stage');
			case 'recovery':
			return publicServerUrlTemplate.replace('%s', '-recovery');
			case 'devel':
			return publicServerUrlTemplate.replace('%s', '-devel');
			case 'live':
			return publicServerUrlTemplate.replace('%s', '');
			default:
			return publicServerUrlTemplate.replace('%s', '');
		}
	}

	getSiffiPublicWebUrl(locale?: string, path: string = '/') {
		var normalizedPath: any = path || '/';
		if (!normalizedPath.startsWith('/')) {
			normalizedPath = '/' + normalizedPath;
		}
		var baseUrl: any = this.siffiLanguageDomains[locale] || this.siffiLanguageDomains['en_GB'];
		return new URL(normalizedPath, baseUrl).toString();
	}

	getPublicWebHomeUrl(origin?: string, locale?: string) {
		if (origin === 'siffi.com') {
			return this.getSiffiPublicWebUrl(locale);
		}
		return this.getPublicWebUrl();
	}

	getPlatformAppUrl(path?: string) {
		var normalizedPath: any = path || '';
		if (normalizedPath && normalizedPath.charAt(0) === '/') {
			normalizedPath = normalizedPath.substring(1);
		}
		return window.location.origin + '/app/#/' + normalizedPath;
	}

	getPlatformBaseUrl() {
		return window.location.origin + '/app/';
	}

	getBaseUrl() {
		return window.location.protocol + '//' + window.location.hostname + (location.port ? ':' + location.port : '');
	}
	
	getRestUrl() {
		if ("{{ENVIRONMENT}}" == config.Settings.ENVIRONMENT) {
			var host: any = window.location.hostname;
			return host.includes("siffi") ? "https://api-devel.siffi.com/" : "https://api-devel.minudoc.ee/";
		} else {
			var host: any = window.location.hostname;
			if (host.includes("minudoc")) {
				var isEelvisiit: any = window.location.href.indexOf('eelvisiit') !== -1;
				var restUrl: any = isEelvisiit ? 'https://eelvisiit%s.minudoc.ee/' : 'https://api%s.minudoc.ee/';
				switch (config.Settings.ENVIRONMENT.toLowerCase()) {
					case 'build':
						return restUrl.replace('%s', '-build');
					case 'test':
						return restUrl.replace('%s', '-test');
					case 'stage':
						return restUrl.replace('%s', '-stage');
					case 'recovery':
						return restUrl.replace('%s', '-recovery');
					case 'devel':
						return restUrl.replace('%s', '-devel');
					case 'live':
						if (isEelvisiit) {
							return 'https://api-eelvisiit.minudoc.ee/';
						} else {
							return restUrl.replace('%s', '');
						}
					default:
						if (isEelvisiit) {
							return 'https://api-eelvisiit.minudoc.ee/';
						} else {
							return restUrl.replace('%s', '');
						}
				}
			} else if (host.includes("siffi")) {
				var restUrl: any = 'https://api%s.siffi.com/';
				switch (config.Settings.ENVIRONMENT.toLowerCase()) {
					case 'build':
						return restUrl.replace('%s', '-build');
					case 'test':
						return restUrl.replace('%s', '-test');
					case 'stage':
						return restUrl.replace('%s', '-stage');
					case 'recovery':
						return restUrl.replace('%s', '-recovery');
					case 'live':
						return restUrl.replace('%s', '');
					default:
						return restUrl.replace('%s', '');
				}
			} else if ("live" == config.Settings.ENVIRONMENT) {
				return "https://www.minudoc.ee/";
			}
		}
	}
	
	getSignalApi() {
		if ('{{ENVIRONMENT}}' == config.Settings.ENVIRONMENT) {
			return 'https://signal-api-test.sentab.com';
		} else if ('live' == config.Settings.ENVIRONMENT) {
			return 'https://signal-api.sentab.com';
		} else {
			return 'https://signal-api-' + config.Settings.ENVIRONMENT + '.sentab.com';
		}
	}
	
	getStripePublishedKey() {
		if ("live" == config.Settings.ENVIRONMENT || "stage" == config.Settings.ENVIRONMENT) {
			return "pk_live_qqIoJYarnqKc9fESFubAsdrR00HN2t3bNN";
		} else {
			return "pk_test_51GsCXcDbGcdSwhhqVt4ERbcktSKVtSEjYGN0o1lgkrKS8COHaWDBAByugtPsKTByNOvTsK2wmV5yNPTfBuDm4Ukh00Q6SfCqYN";
		}
	}
	
	isOnDemandServiceUnavailable(onDemandSettings) {
		var startTimeInHours: any = onDemandSettings['startTimeInHours'];
		var endTimeInHours: any = onDemandSettings['endTimeInHours'];
		var weekendStartTimeInHours: any = onDemandSettings['weekendStartTimeInHours'];
		var weekendEndTimeInHours: any = onDemandSettings['weekendEndTimeInHours'];
		var workingDaysOnly: any = onDemandSettings['workingDaysOnly'];
		var onHold: any = onDemandSettings['onHold'];
		
		if (!startTimeInHours && !endTimeInHours) {
			return onHold;
		}
		
		if (onHold) {
			return true;
		}
		
		var currentDay: any = new Date().getDay();
		var currentHour: any = new Date().getHours();
		var isWeekend: any = (currentDay == 6 || currentDay == 0);
		var offsetInHours: any = new Date().getTimezoneOffset() * -1 / 60;
		
		if (isWeekend && workingDaysOnly) {
			return true;
		}
		
		var isInWeekendWorkingRange: any = false;
		if (weekendStartTimeInHours > 0 && weekendEndTimeInHours > 0) {
			isInWeekendWorkingRange = (currentHour >= (weekendStartTimeInHours + offsetInHours) && currentHour < (weekendEndTimeInHours + offsetInHours));
			if (isWeekend) {
				return !isInWeekendWorkingRange;
			}
		}
		
		var isInGeneralWorkingHoursRange: any = (currentHour >= (startTimeInHours + offsetInHours) && currentHour < (endTimeInHours + offsetInHours));
		return !isInGeneralWorkingHoursRange;
	}
	
	getCounties(country) {
		if (country == 'Estonia') {
			return ['Harju maakond', 'Hiiu maakond', 'Ida-Viru maakond',
			'Järva maakond', 'Jõgeva maakond', 'Lääne maakond',
			'Lääne-Viru maakond', 'Põlva maakond', 'Pärnu maakond',
			'Rapla maakond', 'Saare maakond', 'Tartu maakond',
			'Valga maakond', 'Viljandi maakond', 'Võru maakond'
			];
		} else {
			return null;
		}
	}
	
	getSummaryProblems() {
		return [{
			alias: 'Anxiety',
			labelCode: 'ANXIETY'
		}, {
			alias: 'Stress',
			labelCode: 'STRESS'
		}, {
			alias: 'Anger',
			labelCode: 'ANGER'
		}, {
			alias: 'LSE',
			labelCode: 'LSE'
		}, {
			alias: 'Loneliness',
			labelCode: 'LONELINESS'
		}, {
			alias: 'Mood',
			labelCode: 'MOOD'
		}, {
			alias: 'Motivation',
			labelCode: 'MOTIVATION'
		}, {
			alias: 'Crises',
			labelCode: 'CRISES'
		}, {
			alias: 'Burnout',
			labelCode: 'BURNOUT'
		}, {
			alias: 'Cognition',
			labelCode: 'COGNITION'
		}, {
			alias: 'Sleep',
			labelCode: 'SLEEP'
		}, {
			alias: 'Addiction',
			labelCode: 'ADDICTION'
		}, {
			alias: 'Family',
			labelCode: 'FAMILY'
		}, {
			alias: 'Grief',
			labelCode: 'GRIEF'
		}, {
			alias: 'Trauma',
			labelCode: 'TRAUMA'
		}, {
			alias: 'Suicidality',
			labelCode: 'SUICIDALITY'
		}, {
			alias: 'Eating',
			labelCode: 'EATING'
		}, {
			alias: 'Pain',
			labelCode: 'PAIN'
		}, {
			alias: 'Work',
			labelCode: 'WORK'
		}, {
			alias: 'Develop',
			labelCode: 'DEVELOP'
		}, {
			alias: 'Irritability',
			labelCode: 'IRRITABILITY'
		}, {
			alias: 'Self-harm',
			labelCode: 'SELF_HARM'
		}, {
			alias: 'Other',
			labelCode: 'OTHER'
		}];
	}
	
	getSummarySolutions() {
		return [{
			labelCode: 'NO_ANSWER',
			alias: 'No_answer'
		}, {
			labelCode: 'REF_CP_ECO',
			alias: 'Ref_CP_eco'
		}, {
			labelCode: 'REF_P_ECO',
			alias: 'Ref_P_eco'
		}, {
			labelCode: 'REF_C_ECO',
			alias: 'Ref_C_eco'
		}, {
			labelCode: 'REF_IN_HOUSE',
			alias: 'Ref_In_house'
		}, {
			labelCode: 'REF_EXTERNAL',
			alias: 'Ref_external'
		}, {
			labelCode: 'COUNSELLED',
			alias: 'Counselled'
		}];
	}
	
	getSummarySolutionsForPreVisit() {
		return [{
			labelCode: 'COUNSELLED',
			alias: 'Counselled'
		}, {
			labelCode: 'REF_TO_GP',
			alias: 'Ref_to_gp'
		}];
	}
	
	getCountries() {
		return [{
			name: 'Afghanistan',
			code: 'AF'
		}, {
			name: 'Åland Islands',
			code: 'AX'
		}, {
			name: 'Albania',
			code: 'AL'
		}, {
			name: 'Algeria',
			code: 'DZ'
		}, {
			name: 'American Samoa',
			code: 'AS'
		}, {
			name: 'AndorrA',
			code: 'AD'
		}, {
			name: 'Angola',
			code: 'AO'
		}, {
			name: 'Anguilla',
			code: 'AI'
		}, {
			name: 'Antarctica',
			code: 'AQ'
		}, {
			name: 'Antigua and Barbuda',
			code: 'AG'
		}, {
			name: 'Argentina',
			code: 'AR'
		}, {
			name: 'Armenia',
			code: 'AM'
		}, {
			name: 'Aruba',
			code: 'AW'
		}, {
			name: 'Australia',
			code: 'AU'
		}, {
			name: 'Austria',
			code: 'AT'
		}, {
			name: 'Azerbaijan',
			code: 'AZ'
		}, {
			name: 'Bahamas',
			code: 'BS'
		}, {
			name: 'Bahrain',
			code: 'BH'
		}, {
			name: 'Bangladesh',
			code: 'BD'
		}, {
			name: 'Barbados',
			code: 'BB'
		}, {
			name: 'Belarus',
			code: 'BY'
		}, {
			name: 'Belgium',
			code: 'BE'
		}, {
			name: 'Belize',
			code: 'BZ'
		}, {
			name: 'Benin',
			code: 'BJ'
		}, {
			name: 'Bermuda',
			code: 'BM'
		}, {
			name: 'Bhutan',
			code: 'BT'
		}, {
			name: 'Bolivia',
			code: 'BO'
		}, {
			name: 'Bosnia and Herzegovina',
			code: 'BA'
		}, {
			name: 'Botswana',
			code: 'BW'
		}, {
			name: 'Bouvet Island',
			code: 'BV'
		}, {
			name: 'Brazil',
			code: 'BR'
		}, {
			name: 'British Indian Ocean Territory',
			code: 'IO'
		}, {
			name: 'Brunei Darussalam',
			code: 'BN'
		}, {
			name: 'Bulgaria',
			code: 'BG'
		}, {
			name: 'Burkina Faso',
			code: 'BF'
		}, {
			name: 'Burundi',
			code: 'BI'
		}, {
			name: 'Cambodia',
			code: 'KH'
		}, {
			name: 'Cameroon',
			code: 'CM'
		}, {
			name: 'Canada',
			code: 'CA'
		}, {
			name: 'Cape Verde',
			code: 'CV'
		}, {
			name: 'Cayman Islands',
			code: 'KY'
		}, {
			name: 'Central African Republic',
			code: 'CF'
		}, {
			name: 'Chad',
			code: 'TD'
		}, {
			name: 'Chile',
			code: 'CL'
		}, {
			name: 'China',
			code: 'CN'
		}, {
			name: 'Christmas Island',
			code: 'CX'
		}, {
			name: 'Cocos (Keeling) Islands',
			code: 'CC'
		}, {
			name: 'Colombia',
			code: 'CO'
		}, {
			name: 'Comoros',
			code: 'KM'
		}, {
			name: 'Congo',
			code: 'CG'
		}, {
			name: 'Congo, The Democratic Republic of the',
			code: 'CD'
		}, {
			name: 'Cook Islands',
			code: 'CK'
		}, {
			name: 'Costa Rica',
			code: 'CR'
		}, {
			name: 'Cote D\'Ivoire',
			code: 'CI'
		}, {
			name: 'Croatia',
			code: 'HR'
		}, {
			name: 'Cuba',
			code: 'CU'
		}, {
			name: 'Cyprus',
			code: 'CY'
		}, {
			name: 'Czech Republic',
			code: 'CZ'
		}, {
			name: 'Denmark',
			code: 'DK'
		}, {
			name: 'Djibouti',
			code: 'DJ'
		}, {
			name: 'Dominica',
			code: 'DM'
		}, {
			name: 'Dominican Republic',
			code: 'DO'
		}, {
			name: 'Ecuador',
			code: 'EC'
		}, {
			name: 'Egypt',
			code: 'EG'
		}, {
			name: 'El Salvador',
			code: 'SV'
		}, {
			name: 'Equatorial Guinea',
			code: 'GQ'
		}, {
			name: 'Eritrea',
			code: 'ER'
		}, {
			name: 'Estonia',
			code: 'EE'
		}, {
			name: 'Ethiopia',
			code: 'ET'
		}, {
			name: 'Falkland Islands (Malvinas)',
			code: 'FK'
		}, {
			name: 'Faroe Islands',
			code: 'FO'
		}, {
			name: 'Fiji',
			code: 'FJ'
		}, {
			name: 'Finland',
			code: 'FI'
		}, {
			name: 'France',
			code: 'FR'
		}, {
			name: 'French Guiana',
			code: 'GF'
		}, {
			name: 'French Polynesia',
			code: 'PF'
		}, {
			name: 'French Southern Territories',
			code: 'TF'
		}, {
			name: 'Gabon',
			code: 'GA'
		}, {
			name: 'Gambia',
			code: 'GM'
		}, {
			name: 'Georgia',
			code: 'GE'
		}, {
			name: 'Germany',
			code: 'DE'
		}, {
			name: 'Ghana',
			code: 'GH'
		}, {
			name: 'Gibraltar',
			code: 'GI'
		}, {
			name: 'Greece',
			code: 'GR'
		}, {
			name: 'Greenland',
			code: 'GL'
		}, {
			name: 'Grenada',
			code: 'GD'
		}, {
			name: 'Guadeloupe',
			code: 'GP'
		}, {
			name: 'Guam',
			code: 'GU'
		}, {
			name: 'Guatemala',
			code: 'GT'
		}, {
			name: 'Guernsey',
			code: 'GG'
		}, {
			name: 'Guinea',
			code: 'GN'
		}, {
			name: 'Guinea-Bissau',
			code: 'GW'
		}, {
			name: 'Guyana',
			code: 'GY'
		}, {
			name: 'Haiti',
			code: 'HT'
		}, {
			name: 'Heard Island and Mcdonald Islands',
			code: 'HM'
		}, {
			name: 'Holy See (Vatican City State)',
			code: 'VA'
		}, {
			name: 'Honduras',
			code: 'HN'
		}, {
			name: 'Hong Kong',
			code: 'HK'
		}, {
			name: 'Hungary',
			code: 'HU'
		}, {
			name: 'Iceland',
			code: 'IS'
		}, {
			name: 'India',
			code: 'IN'
		}, {
			name: 'Indonesia',
			code: 'ID'
		}, {
			name: 'Iran, Islamic Republic Of',
			code: 'IR'
		}, {
			name: 'Iraq',
			code: 'IQ'
		}, {
			name: 'Ireland',
			code: 'IE'
		}, {
			name: 'Isle of Man',
			code: 'IM'
		}, {
			name: 'Israel',
			code: 'IL'
		}, {
			name: 'Italy',
			code: 'IT'
		}, {
			name: 'Jamaica',
			code: 'JM'
		}, {
			name: 'Japan',
			code: 'JP'
		}, {
			name: 'Jersey',
			code: 'JE'
		}, {
			name: 'Jordan',
			code: 'JO'
		}, {
			name: 'Kazakhstan',
			code: 'KZ'
		}, {
			name: 'Kenya',
			code: 'KE'
		}, {
			name: 'Kiribati',
			code: 'KI'
		}, {
			name: 'Korea, Democratic People\'s Republic of',
			code: 'KP'
		}, {
			name: 'Korea, Republic of',
			code: 'KR'
		}, {
			name: 'Kuwait',
			code: 'KW'
		}, {
			name: 'Kyrgyzstan',
			code: 'KG'
		}, {
			name: 'Lao People\'s Democratic Republic',
			code: 'LA'
		}, {
			name: 'Latvia',
			code: 'LV'
		}, {
			name: 'Lebanon',
			code: 'LB'
		}, {
			name: 'Lesotho',
			code: 'LS'
		}, {
			name: 'Liberia',
			code: 'LR'
		}, {
			name: 'Libyan Arab Jamahiriya',
			code: 'LY'
		}, {
			name: 'Liechtenstein',
			code: 'LI'
		}, {
			name: 'Lithuania',
			code: 'LT'
		}, {
			name: 'Luxembourg',
			code: 'LU'
		}, {
			name: 'Macao',
			code: 'MO'
		}, {
			name: 'Macedonia, The Former Yugoslav Republic of',
			code: 'MK'
		}, {
			name: 'Madagascar',
			code: 'MG'
		}, {
			name: 'Malawi',
			code: 'MW'
		}, {
			name: 'Malaysia',
			code: 'MY'
		}, {
			name: 'Maldives',
			code: 'MV'
		}, {
			name: 'Mali',
			code: 'ML'
		}, {
			name: 'Malta',
			code: 'MT'
		}, {
			name: 'Marshall Islands',
			code: 'MH'
		}, {
			name: 'Martinique',
			code: 'MQ'
		}, {
			name: 'Mauritania',
			code: 'MR'
		}, {
			name: 'Mauritius',
			code: 'MU'
		}, {
			name: 'Mayotte',
			code: 'YT'
		}, {
			name: 'Mexico',
			code: 'MX'
		}, {
			name: 'Micronesia, Federated States of',
			code: 'FM'
		}, {
			name: 'Moldova, Republic of',
			code: 'MD'
		}, {
			name: 'Monaco',
			code: 'MC'
		}, {
			name: 'Mongolia',
			code: 'MN'
		}, {
			name: 'Montserrat',
			code: 'MS'
		}, {
			name: 'Morocco',
			code: 'MA'
		}, {
			name: 'Mozambique',
			code: 'MZ'
		}, {
			name: 'Myanmar',
			code: 'MM'
		}, {
			name: 'Namibia',
			code: 'NA'
		}, {
			name: 'Nauru',
			code: 'NR'
		}, {
			name: 'Nepal',
			code: 'NP'
		}, {
			name: 'Netherlands',
			code: 'NL'
		}, {
			name: 'Netherlands Antilles',
			code: 'AN'
		}, {
			name: 'New Caledonia',
			code: 'NC'
		}, {
			name: 'New Zealand',
			code: 'NZ'
		}, {
			name: 'Nicaragua',
			code: 'NI'
		}, {
			name: 'Niger',
			code: 'NE'
		}, {
			name: 'Nigeria',
			code: 'NG'
		}, {
			name: 'Niue',
			code: 'NU'
		}, {
			name: 'Norfolk Island',
			code: 'NF'
		}, {
			name: 'Northern Mariana Islands',
			code: 'MP'
		}, {
			name: 'Norway',
			code: 'NO'
		}, {
			name: 'Oman',
			code: 'OM'
		}, {
			name: 'Pakistan',
			code: 'PK'
		}, {
			name: 'Palau',
			code: 'PW'
		}, {
			name: 'Palestinian Territory, Occupied',
			code: 'PS'
		}, {
			name: 'Panama',
			code: 'PA'
		}, {
			name: 'Papua New Guinea',
			code: 'PG'
		}, {
			name: 'Paraguay',
			code: 'PY'
		}, {
			name: 'Peru',
			code: 'PE'
		}, {
			name: 'Philippines',
			code: 'PH'
		}, {
			name: 'Pitcairn',
			code: 'PN'
		}, {
			name: 'Poland',
			code: 'PL'
		}, {
			name: 'Portugal',
			code: 'PT'
		}, {
			name: 'Puerto Rico',
			code: 'PR'
		}, {
			name: 'Qatar',
			code: 'QA'
		}, {
			name: 'Reunion',
			code: 'RE'
		}, {
			name: 'Romania',
			code: 'RO'
		}, {
			name: 'Russian Federation',
			code: 'RU'
		}, {
			name: 'RWANDA',
			code: 'RW'
		}, {
			name: 'Saint Helena',
			code: 'SH'
		}, {
			name: 'Saint Kitts and Nevis',
			code: 'KN'
		}, {
			name: 'Saint Lucia',
			code: 'LC'
		}, {
			name: 'Saint Pierre and Miquelon',
			code: 'PM'
		}, {
			name: 'Saint Vincent and the Grenadines',
			code: 'VC'
		}, {
			name: 'Samoa',
			code: 'WS'
		}, {
			name: 'San Marino',
			code: 'SM'
		}, {
			name: 'Sao Tome and Principe',
			code: 'ST'
		}, {
			name: 'Saudi Arabia',
			code: 'SA'
		}, {
			name: 'Senegal',
			code: 'SN'
		}, {
			name: 'Serbia and Montenegro',
			code: 'CS'
		}, {
			name: 'Seychelles',
			code: 'SC'
		}, {
			name: 'Sierra Leone',
			code: 'SL'
		}, {
			name: 'Singapore',
			code: 'SG'
		}, {
			name: 'Slovakia',
			code: 'SK'
		}, {
			name: 'Slovenia',
			code: 'SI'
		}, {
			name: 'Solomon Islands',
			code: 'SB'
		}, {
			name: 'Somalia',
			code: 'SO'
		}, {
			name: 'South Africa',
			code: 'ZA'
		}, {
			name: 'South Georgia and the South Sandwich Islands',
			code: 'GS'
		}, {
			name: 'Spain',
			code: 'ES'
		}, {
			name: 'Sri Lanka',
			code: 'LK'
		}, {
			name: 'Sudan',
			code: 'SD'
		}, {
			name: 'Suriname',
			code: 'SR'
		}, {
			name: 'Svalbard and Jan Mayen',
			code: 'SJ'
		}, {
			name: 'Swaziland',
			code: 'SZ'
		}, {
			name: 'Sweden',
			code: 'SE'
		}, {
			name: 'Switzerland',
			code: 'CH'
		}, {
			name: 'Syrian Arab Republic',
			code: 'SY'
		}, {
			name: 'Taiwan, Province of China',
			code: 'TW'
		}, {
			name: 'Tajikistan',
			code: 'TJ'
		}, {
			name: 'Tanzania, United Republic of',
			code: 'TZ'
		}, {
			name: 'Thailand',
			code: 'TH'
		}, {
			name: 'Timor-Leste',
			code: 'TL'
		}, {
			name: 'Togo',
			code: 'TG'
		}, {
			name: 'Tokelau',
			code: 'TK'
		}, {
			name: 'Tonga',
			code: 'TO'
		}, {
			name: 'Trinidad and Tobago',
			code: 'TT'
		}, {
			name: 'Tunisia',
			code: 'TN'
		}, {
			name: 'Turkey',
			code: 'TR'
		}, {
			name: 'Turkmenistan',
			code: 'TM'
		}, {
			name: 'Turks and Caicos Islands',
			code: 'TC'
		}, {
			name: 'Tuvalu',
			code: 'TV'
		}, {
			name: 'Uganda',
			code: 'UG'
		}, {
			name: 'Ukraine',
			code: 'UA'
		}, {
			name: 'United Arab Emirates',
			code: 'AE'
		}, {
			name: 'United Kingdom',
			code: 'GB'
		}, {
			name: 'United States',
			code: 'US'
		}, {
			name: 'United States Minor Outlying Islands',
			code: 'UM'
		}, {
			name: 'Uruguay',
			code: 'UY'
		}, {
			name: 'Uzbekistan',
			code: 'UZ'
		}, {
			name: 'Vanuatu',
			code: 'VU'
		}, {
			name: 'Venezuela',
			code: 'VE'
		}, {
			name: 'Viet Nam',
			code: 'VN'
		}, {
			name: 'Virgin Islands, British',
			code: 'VG'
		}, {
			name: 'Virgin Islands, U.S.',
			code: 'VI'
		}, {
			name: 'Wallis and Futuna',
			code: 'WF'
		}, {
			name: 'Western Sahara',
			code: 'EH'
		}, {
			name: 'Yemen',
			code: 'YE'
		}, {
			name: 'Zambia',
			code: 'ZM'
		}, {
			name: 'Zimbabwe',
			code: 'ZW'
		}];
	}
	
	getSettings() {
		return config.Settings;
	}
	
	getBroadcastConfig() {
		return config.Broadcast;
	}
	
	getBookingConfig() {
		return config.Booking;
	}
	
	getCallConfig() {
		return config.Call;
	}
	
	getTimerConfig() {
		return config.Timer;
	}
	
	getOtherConfig() {
		return config.Other;
	}
	
	getSymptomCheckConfig() {
		return config.Symptom_Check;
	}
	
	getPharmacyConfig() {
		return config.Pharmacy;
	}
	
	getPreVisitConfig() {
		return config.PreVisit;
	}
	
}
